const host = {
  dev: 'http://9.208.69.124:8080',
  prod: 'http://9.208.68.50:8080',
};

module.exports = {
  host,
};
